export const config = {
  title: "Berqus Appliance Repair Services",
  meta: {
    description:
      "Berqus Appliance Repair offers expert appliance repair services in Miami, FL, and surrounding areas. Specializing in washing machine, stove, and refrigerator repairs.",
    keywords: [
      "Appliance Repair Miami",
      "Washing Machine Repair",
      "Stove Repair",
      "Refrigerator Repair",
      "Berqus Appliance Services",
    ],
    author: "Berqus Appliance Repair Services",
    canonicalUrl: "https://www.berqusllc.com/",
  },
  sections: {
    header: {
      businessName: "Berqus Appliance Repair Services",
    },
    sectionB: {
      heroTitle: "Your Trusted Appliance Repair Partner",
      heroSubtitle: "Expert Repairs for Your Home Appliances",
      learnAboutText: "Explore Our Services",
      phoneNumber: "5617102882",
      phoneLabel: "(561) 710-2882",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/496319058/photo/replacing-engine-of-washing-machine.jpg?s=612x612&w=0&k=20&c=iFQPqdxOuY5Rb_3U9A_24Ck507QzvZ7vHNkitvcQrQ8=", // Replace with actual image URL
      cardData: [
        {
          title: "Dryer Repair",
          description:
            "Efficient and reliable washing machine repair services to keep your laundry routine uninterrupted.",
        },
        {
          title: "Dishwasher Repair",
          description:
            "We understand the inconvenience of a broken dishwasher, which is why we offer prompt and professional service to diagnose and fix the issue.",
        },
        {
          title: "Appliance Repair",
          description:
            "Our professional appliance repair technicians are here to provide quick and reliable solutions for all your appliance repair needs. ",
        },
      ],
      description:
        "At Berqus Appliance Repair Services, we are committed to providing top-notch appliance repair solutions in Miami, FL. Our experienced technicians ensure your appliances are back in working order swiftly and efficiently.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive appliance repair services tailored to meet your needs.",
      cards: [
        {
          title: "Washing Machine Repair",
          description:
            "Expert repair services for all types of washing machines, ensuring optimal performance.",
          imageSrc:
            "https://media.istockphoto.com/id/1078745094/photo/repair-and-service-of-a-damaged-washing-machine.jpg?s=612x612&w=0&k=20&c=ZXnHkNHl-N_i9FcEn56mEqQXHpP8qdlZGfaH6qRs3m4=", // Replace with actual image URL
          imageAlt: "Washing Machine Repair",
        },
        {
          title: "Stove Repair",
          description:
            "Reliable stove repair services to ensure your cooking appliances are safe and efficient.",
          imageSrc:
            "https://media.istockphoto.com/id/1285501269/photo/repairs-and-fixing-of-gas-control-panel-man-hand-in-protective-gloves-repairs-hotplate-of-hob.jpg?s=612x612&w=0&k=20&c=Sa-PhSRWlA23SmgN0VWu6Op20i4jt1ndeEdI2JURDhs=", // Replace with actual image URL
          imageAlt: "Stove Repair",
        },
        {
          title: "Refrigerator Repair",
          description:
            "Prompt and professional refrigerator repair services to keep your food fresh.",
          imageSrc:
            "https://media.istockphoto.com/id/176026558/photo/pouring-hot-water-onto-iced-element-in-fridge.jpg?s=612x612&w=0&k=20&c=-d3wUwbFHIgPQra2H3jo6_JfNGysV8RP2wHTl1n5rYo=", // Replace with actual image URL
          imageAlt: "Refrigerator Repair",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: ["Freezer Repair", "Oven Repair", "Microwave Repair"],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://assets.voolt.com/assets/2023/01/13235747/aboutus-hero-trade-1200x800-4.jpg", // Replace with actual image URL
        alt: "Berqus Appliance Repair Team",
      },
      aboutText: [
        "With years of experience in the appliance repair industry, Berqus Appliance Repair Services is dedicated to providing exceptional repair solutions.",
        "Our team of skilled technicians ensures that your appliances are repaired efficiently, minimizing downtime and inconvenience.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Berqus Appliance Repair Services Logo",
      businessName: "Berqus Appliance Repair Services",
      contact: {
        phone: "5617102882",
        phoneLabel: "(561) 710-2882",
        email: "berqusappliancerepair@gmail.com",
        website: "https://www.berqusllc.com/",
        address: "380 NE 194th Ter, Miami, FL 33179",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "380 NE 194th Ter, Miami, FL 33179",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.123456789!2d-80.1234567!3d25.9487654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abc123456789%3A0xabcdef1234567890!2s380%20NE%20194th%20Ter%2C%20Miami%2C%20FL%2033179!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
